/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */


theme_custom.customEvent = function() {
  $('#search_country').on('input', function() {
    var searchText = $(this).val().toLowerCase();
    var countryList = $('#country_list_main');
    var notFoundMessage = $('#not_found_message');
    notFoundMessage.hide();
    
    countryList.find('.country_name').each(function() {
      var countryItem = $(this);
      var countryName = countryItem.find('.country_link').text().toLowerCase();    
      if (countryName.startsWith(searchText)) {
        countryItem.show();
      } else {
        countryItem.hide();
      }
    });
    
    if(searchText == ''){
      countryList.hide();
    }else{
      countryList.show();    
    }

    if (countryList.find('.country_name:visible').length == 0) {
      notFoundMessage.show();
    }else{
      notFoundMessage.hide();
    }

  });

  window.addEventListener('scroll', onScroll);
  const customBrandRichMain = document.querySelector(".custom_brand_rich_main")?.offsetTop;
  const customCounterMain = document.querySelector(".custom_counter_section")?.offsetTop;
  
  var hasRun = false;  
  function onScroll(){
    var scroll = $(window).scrollTop() + 475;
    if (scroll > customBrandRichMain && !hasRun) {
      brandRichCountdown();
      hasRun = true;
    }
    if (scroll > customCounterMain && !hasRun) {
      customCounterSection();
      hasRun = true;
    }
  }
  onScroll();
  

  function brandRichCountdown(){
    const counters = document.querySelectorAll(".custom_brand_rich_main .brand_rich_block .heading");
    counters?.forEach((counter) => {
      counter.innerText = "0";
      const updateCounter = () => {
        const target = +counter.getAttribute("data-val");
        const count = +counter.innerText;
        const increment = target / 200;
        if (count < target) {
          counter.innerText = `${Math.ceil(count + increment)}`;
          setTimeout(updateCounter, 1);
        } else{
          counter.innerText = target.toLocaleString();          
        }
      };
      updateCounter();
    });
  }
  
  function customCounterSection(){
    const counters = document.querySelectorAll(".custom_counter_section .number");
    counters?.forEach((counter) => {
      counter.innerText = "0";
      const updateCounter = () => {
        const target = +counter.getAttribute("data-val");
        const count = +counter.innerText;
        const increment = target / 200;
        if (count < target) {
          counter.innerText = `${Math.ceil(count + increment)}`;
          setTimeout(updateCounter, 1);
        } else{
          counter.innerText = target.toLocaleString();          
        }
      };
      updateCounter();
    });
  }

  $("#enable_contact_btn_checkbox").on('change', function() {
    if ($(this).is(':checked')) {
      $(this).parents('.contact__form').find('button').removeClass('disabled');
    } else {
      $(this).parents('.contact__form').find('button').addClass('disabled');
    }    
  });
  
}

theme_custom.megaMenuImageGet = function() {
  $('.mega-menu__column a').each(function() {
    var defaultImgSrc = $(this).closest(".mega-menu__inner").find(".mega-menu__images-wrapper img").attr("src");
    var collectionImgSrc = $(this).closest(".mega-menu__column").find(".mega_menu_hover_img").attr('data-src');
    $(this).on({
      mouseenter: function () {
        if(collectionImgSrc != undefined){
          $(this).closest(".mega-menu__inner").find(".mega-menu__images-wrapper img").attr("src", collectionImgSrc);
          $(this).closest(".mega-menu__inner").find(".mega-menu__images-wrapper img").attr("srcset", collectionImgSrc);
        }
      },
      mouseleave: function () {
        $(this).closest(".mega-menu__inner").find(".mega-menu__images-wrapper img").attr("src", defaultImgSrc);
        $(this).closest(".mega-menu__inner").find(".mega-menu__images-wrapper img").attr("srcset", defaultImgSrc);
      }
    });
  });
}

theme_custom.productFeaturedData = function() {
  $(".main_product_featured_section .visually-hidden table tr").each(function() {
    var getValue = $(this).find("td").html();
    // Description get 
    if(getValue == 'description'){
      var allDescription = $(this).closest('tr').find('td:eq(1)').html();
      if(allDescription != undefined){
        $('.product-description-column [data-custom-field="description"]').html(allDescription);
      }
    }
    // extra-img1 get
    if(getValue == 'extra-img1'){
      var allExtraImg1 = $(this).closest('tr').find('td:eq(1)').html();
      if(allExtraImg1 != undefined){
        $('.product-description-column img[data-custom-field-img="extra-img1"]').attr("src", allExtraImg1);
      }
    }
    // extra-img2 get
    if(getValue == 'extra-img2'){
      var allExtraImg2 = $(this).closest('tr').find('td:eq(1)').html();
      if(allExtraImg2 != undefined){
        $('.product-description-column img[data-custom-field-img="extra-img2"]').attr("src", allExtraImg2);
      }
    }
    // compare-chart get
    if(getValue == 'compare-chart'){
      var allCompareChart = $(this).closest('tr').find('td:eq(1)').html();
      console.log("allCompareChart",allCompareChart);
      if(allCompareChart != undefined){
        $('.product-chart-section [data-custom-field="compare-chart"]').html(allCompareChart);
      }
    }else{
      // $("#product-chart").addClass("visually-hidden");
    }
  });
}

theme_custom.regionsToggle = function() {
  $(".product-region").on("click", function(){
    $(this).closest(".regions_toggle").toggleClass("active");
  });
}

theme_custom.imageWithtextSlider = function()
{
  $('.image_with_text_slider').slick();
}

// theme_custom.warranty_registration = function(){
//   let inter = setInterval(function(){ 
//     if($("#16443-select-2")){ 
//       setTimeout(function(){
//         document.getElementById("16443-text-4").type = "date"
//         var dtToday = new Date();
//         var month = dtToday.getMonth() + 1;
//         var day = dtToday.getDate();
//         var year = dtToday.getFullYear();
//         if(month < 10)
//           month = '0' + month.toString();
//         if(day < 10)
//           day = '0' + day.toString();
//         var maxDate = year + '-' + month + '-' + day;
    
//         $('#16443-text-4').attr('max', maxDate);
//         clearInterval(inter); 
//       },500)
//     }
//   },1000)
// }


window.addEventListener('DOMContentLoaded', themeCustomInit);

function themeCustomInit() {
  theme_custom.customEvent();
  theme_custom.megaMenuImageGet();
  // theme_custom.productFeaturedData();
  theme_custom.regionsToggle();
  theme_custom.imageWithtextSlider();
  // theme_custom.warranty_registration();
}
